var React = require('react');

function IconCheckboxOn (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M24.333 3H5.667A2.675 2.675 0 0 0 3 5.667v18.666A2.675 2.675 0 0 0 5.667 27h18.666A2.675 2.675 0 0 0 27 24.333V5.667A2.675 2.675 0 0 0 24.333 3zm0 21.333H5.667V5.667h18.666zM22.987 11l-1.88-1.893-8.787 8.786-3.44-3.426-1.893 1.88 5.333 5.32z","transform":"translate(-3 -3)"}));
}

IconCheckboxOn.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconCheckboxOn;

IconCheckboxOn.default = IconCheckboxOn;
